import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  
  media: {

    marginLeft: '15px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },
  mediar: {

    marginLeft: '5px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },
  media2: {
    width: "auto",
    height: "auto",
    marginLeft: '5px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },
  media3: {
    width: "20%",
    height: "20%",
    marginLeft: '45px',
    margin: '20px 20px',
    paddingTop: '60.25%',
  },


  mapmedia: {
    height: 0,
    marginLeft: '15px',
    borderRadius: 15,
    margin: '20px 20px',
    paddingTop: '56.25%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backgroundBlendMode: 'darken',
  },
  border: {
    border: 'solid',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '15px',
    height: '100%',
    position: 'relative',
  },
  highlight: {
    fontFamily: 'Poppins',
    fontSize: 20,
    position: 'absolute',
    fontStyle: 'bold',
    fontWeight: 'fontWeightBold',
    color: 'rgba(107, 54, 247, 1)',
  },
  highlight1: {
    fontFamily: 'Poppins',
    fontSize: 16,
    position: 'absolute',
    fontStyle: 'bold',
    fontWeight: 'fontWeightBold',
    color: 'rgba(107, 54, 247, 1)',
  },
  normal: {
    fontFamily: 'Poppins',
    fontSize: 18,
    color: 'rgba(51, 51, 51, 1)',
    
  },
  normal1: {
    fontFamily: 'Poppins',
    fontSize: 16,
    color: 'rgba(51, 51, 51, 1)',
  },
  normal2: {
    fontFamily: 'Poppins',
    fontSize: 16
    ,
    color: 'rgba(51, 51, 51, 1)',
  },
  grid: {
    display: 'flex',
  },
});